import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";

const DropdownManagementFormData = {
    name: "Dropdown Management Form",
    initialState: {
        dropdownManagement: null,
    },
    section: [
        {
          title: "DropdownManagementFormData",
          row: {},
          style: {
            sectionStyle: "row verticle-form",
          },
          rowGroup: [
            {
              groupLabel: "DropdownManagementFormData", // Group for contact fields
              style: {
                groupStyle: "col-lg-12 col-md-12 mb-2",
              },
              groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
              fields: [

                {
                  id: "dropdownManagement",
                  label: "Dropdown Management",
                  Field_Name: "Dropdown Management",
                  fieldType: FormFieldTypes.SELECT,
                  dataField: "dropdownManagement",
                  fieldSetting: {
                    placeholder: "Select",
                    options: [],
                  },
                  style: {
                    containerCss: "col-lg-6 col-md-6 validation-left-0 mb-2",
                  },
                },
              ],
            },
          ],
        },
      ],
    
}

export default DropdownManagementFormData;